const Hero = () => {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/bb3b1b82-9e80-4112-a465-ebc65da33da9/04e6663f-6745-4c38-955a-fe85755f1bb3_clinica.png?v=8e3953df862cd78cad99d1a854d48146"
          alt="MG+ Saúde Oral – clínica de estética e ortodontia no Centro de Santo André SP"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/65" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 flex flex-col items-center">
        {/* Badge */}
        <span className="inline-block text-[#C4A45A] border border-[#C4A45A]/60 text-xs tracking-[0.3em] uppercase font-raleway px-5 py-1.5 rounded-full mb-6 animate-fade-in">
          Santo André · SP · Centro
        </span>

        {/* Headline */}
        <h1 className="font-cormorant text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white font-light leading-tight max-w-4xl mb-4">
          Cuidado que
          <span className="text-[#C4A45A] italic"> transforma.</span>
          <br />
          Beleza que
          <span className="text-[#C4A45A] italic"> confia.</span>
        </h1>

        {/* Subtitle */}
        <p className="font-raleway text-white/85 text-base md:text-lg font-light tracking-wide max-w-xl mb-10 leading-relaxed">
          Tratamentos estéticos personalizados com foco em saúde, bem‑estar e autoestima no Centro de Santo André.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <button
            onClick={() => handleNav('#contato')}
            className="bg-[#C4A45A] text-white font-raleway text-sm tracking-[0.15em] uppercase px-8 py-3.5 rounded-full hover:bg-[#B8975A] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
          >
            Agende sua Avaliação
          </button>
          <a
            href="https://wa.me/551122289498"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="border border-white/70 text-white font-raleway text-sm tracking-[0.15em] uppercase px-8 py-3.5 rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Fale Conosco
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/60 text-xs font-raleway tracking-widest uppercase">Conheça</span>
          <i className="ri-arrow-down-line text-white/60 text-lg"></i>
        </div>
      </div>
    </section>
  );
};

export default Hero;
